import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from 'src/environments/environment.dev';
import {
    CreateStockAllocationPayload,
    CreateStockPayload,
    CreateStockResponse,
    DocumentUploadResponse,
    FaceValueStockDTO,
    RecallStockPayload,
    RecallStockResponse,
    ReportUsagePayload,
    StockAllocationsResponse,
    StockUsageResponse,
} from '../api/face-value';

@Injectable({
    providedIn: 'root',
})
export class FaceValueService {
    private url = environment.apiUrl;
    constructor(private httpClient: HttpClient) {}

    addNewStock(payload: CreateStockPayload): Observable<CreateStockResponse> {
        return this.httpClient.post<CreateStockResponse>(
            `${environment.apiUrl}/api/face-value-management/new-stock`,
            payload
        );
    }

    fetchAllStockBatches(): Observable<FaceValueStockDTO[]> {
        return this.httpClient.get<FaceValueStockDTO[]>(
            `${environment.apiUrl}/api/face-value-management/new-stock`
        );
    }

    allocateStock(payload: CreateStockAllocationPayload): Observable<any> {
        return this.httpClient.post<any>(
            `${environment.apiUrl}/api/face-value-management/stock-allocation`,
            payload
        );
    }

    fetchAgentAllocations(
        userId: number
    ): Observable<StockAllocationsResponse> {
        return this.httpClient.get<StockAllocationsResponse>(
            `${environment.apiUrl}/api/face-value-management/allocations/user/${userId}`
        );
    }

    reportNewUsage(
        payload: ReportUsagePayload
    ): Observable<StockUsageResponse> {
        return this.httpClient.post<StockUsageResponse>(
            `${environment.apiUrl}/api/face-value-management/stock-usage`,
            payload
        );
    }

    recallStock(payload: RecallStockPayload): Observable<RecallStockResponse> {
        return this.httpClient.post<RecallStockResponse>(
            `${environment.apiUrl}/api/face-value-management/recall-stock`,
            payload
        );
    }

    uploadFiles(formData: FormData): Observable<DocumentUploadResponse> {
        return this.httpClient.post<DocumentUploadResponse>(
            `${environment.apiUrl}/file-upload`,
            formData
        );
    }
}
